export default "__VITE_ASSET__CpIT5Aat__"